import { ReactElement } from 'react';

export const SwaggerIcon = (color?: string): ReactElement => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_12176_10874)">
        <path
          d="M15.1875 12H15.1975"
          stroke={color ? color : '#000000'}
          strokeWidth="1.9125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 12H12.01"
          stroke={color ? color : '#000000'}
          strokeWidth="1.9125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.8125 12H8.8225"
          stroke={color ? color : '#000000'}
          strokeWidth="1.9125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.6875 19.4375C6.12391 19.4375 5.58341 19.2136 5.1849 18.8151C4.78638 18.4166 4.5625 17.8761 4.5625 17.3125V13.0625L3.5 12L4.5625 10.9375V6.6875C4.5625 6.12392 4.78638 5.58341 5.1849 5.1849C5.58341 4.78638 6.12391 4.5625 6.6875 4.5625"
          stroke={color ? color : '#000000'}
          strokeWidth="1.675"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.3125 19.4375C17.8761 19.4375 18.4166 19.2136 18.8151 18.8151C19.2136 18.4166 19.4375 17.8761 19.4375 17.3125V13.0625L20.5 12L19.4375 10.9375V6.6875C19.4375 6.12392 19.2136 5.58341 18.8151 5.1849C18.4166 4.78638 17.8761 4.5625 17.3125 4.5625"
          stroke={color ? color : '#000000'}
          strokeWidth="1.675"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_12176_10874">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
